import { useEffect, useState } from "react"
import { Alert, Row, Col, Card, CardBody, CardHeader } from "reactstrap"
import { Link } from "react-router-dom"
import Application from "services/applications/Application.service"

let officerInfo = JSON.parse(localStorage.getItem("authUser"))
let appService = new Application(officerInfo)

const RecallApplication = props => {
  const [recallSuccess, setrecallSuccess] = useState(false)
  const [loading, setloading] = useState(false)
  const [serverError, setserverError] = useState(false)

  useEffect(() => {
    // console.log("appid --> " + props.applicationId)
  }, [])
  const handleRecallButton = async () => {
    if (confirm("Proceed to Recall Application?")) {
    //   console.log("confirmed")
      setloading(true)

      const response = await appService.recallApplication({application_id: props.applicationId})
    //   console.log("server response -> ", response)
      if (response.status) {
        setrecallSuccess(true)
        setserverError(false)
      } else {
        setserverError(true)
        setrecallSuccess(false)
        setloading(false)
      }
      
      
    }
  }
  return (
    <>
      <Card>
        <CardHeader className="alert alert-danger">
          Recall Application
        </CardHeader>

        {recallSuccess ? (
          <>
            <Row className="alert alert-success">
                    <Col md="8">Application successfully recalled</Col>
                    <Col md="4">
                      <Link to="/dashboard" style={{ float: "right" }}>
                        Back
                      </Link>
                    </Col>
                  </Row>
          </>
        ) : (
          <CardBody>
            {serverError? <Alert color="danger">There was an error processing your request. Please try again!</Alert> : null}
            <p>
              You have chosen to have this application <b>Recalled</b>.<br></br>
              By clicking on the confirm button below, the following will take
              place:
              <br></br>
              <ul>
                <li>
                  The application will be returned to the Department Approved
                  status
                </li>
                <li>
                  The application must be reviewed again by the you. To do this,
                  you have to go back to your <b>Dashboard</b> and access the
                  application again from the list of applications.
                </li>
              </ul>
              Please click on the button below to Recall this application.
            </p>

            {loading === true ? (
              <span
                className="spinner-border text-info"
                style={{ float: "right" }}
              ></span>
            ) : (
              <button onClick={handleRecallButton} className="btn btn-danger">
                Confirm Recall Application
              </button>
            )}
          </CardBody>
        )}
      </Card>
    </>
  )
}

export default RecallApplication
